import { useState } from "react";
import { saveBalanceAdjustment } from "../Api/BalanceAdjustmentAdvanceReq";
import { Container, Form, Button, Row, Col, Spinner } from "react-bootstrap";
import { Accordion, AccordionItem, AccordionBody } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";
import "../Styling/ResetButton.css";

const BalanceAdjustmentAdvanceReq = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("userId") || "5";

  const [adjustmentData, setAdjustmentData] = useState({
    employeeName: "",
    totalAdvanceAmountDisbursed: "",
    totalActualExpenses: "",
    balanceAmount: "",
    adjustmentType: "",
    adjustmentDate: "",
    adjustmentMode: "",
    approvedBy: "",
    remarks: "",
    advanceReqId: "",
    createdBy: userId
  });

  const handleChange = (e) => {
    setAdjustmentData({ ...adjustmentData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const dataToSend = {
        ...adjustmentData,
        createdBy: userId
      };

      await saveBalanceAdjustment(dataToSend);
      toast.success(`🦄 Balance Adjustment Added Successfully`);

      setAdjustmentData({
        employeeName: "",
        totalAdvanceAmountDisbursed: "",
        totalActualExpenses: "",
        balanceAmount: "",
        adjustmentType: "",
        adjustmentDate: "",
        adjustmentMode: "",
        approvedBy: "",
        remarks: "",
        advanceReqId: "",
        createdBy: userId
      });

    } catch (error) {
      toast.error(`🦄 Some Error Happened`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container asset-master-fields">
        <h2 className="fields-title">Balance Adjustment Advance Request</h2>

        {loading && (
          <span className="d-inline-flex align-items-center gap-2">
            <Spinner animation="border" size="sm" /> Saving...
          </span>
        )}

        <Form onSubmit={handleSubmit} className="fields-form">

          <Accordion defaultActiveKey="0" className="asset-master-accordion">
            <AccordionItem eventKey="0">
              <AccordionBody>

                <Row className="g-3">

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group>
                      <Form.Label>Employee Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="employeeName"
                        value={adjustmentData.employeeName}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group>
                      <Form.Label>Total Advance Amount Disbursed</Form.Label>
                      <Form.Control
                        type="number"
                        name="totalAdvanceAmountDisbursed"
                        value={adjustmentData.totalAdvanceAmountDisbursed}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group>
                      <Form.Label>Total Actual Expenses</Form.Label>
                      <Form.Control
                        type="text"
                        name="totalActualExpenses"
                        value={adjustmentData.totalActualExpenses}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group>
                      <Form.Label>Balance Amount</Form.Label>
                      <Form.Control
                        type="number"
                        name="balanceAmount"
                        value={adjustmentData.balanceAmount}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group>
                      <Form.Label>Adjustment Type</Form.Label>
                      <Form.Control
                        type="text"
                        name="adjustmentType"
                        value={adjustmentData.adjustmentType}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group>
                      <Form.Label>Adjustment Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="adjustmentDate"
                        value={adjustmentData.adjustmentDate}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group>
                      <Form.Label>Adjustment Mode</Form.Label>
                      <Form.Control
                        type="text"
                        name="adjustmentMode"
                        value={adjustmentData.adjustmentMode}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group>
                      <Form.Label>Approved By</Form.Label>
                      <Form.Control
                        type="text"
                        name="approvedBy"
                        value={adjustmentData.approvedBy}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group>
                      <Form.Label>Advance Request ID</Form.Label>
                      <Form.Control
                        type="text"
                        name="advanceReqId"
                        value={adjustmentData.advanceReqId}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={12}>
                    <Form.Group>
                      <Form.Label>Remarks</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        name="remarks"
                        value={adjustmentData.remarks}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                </Row>

              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: 16 }}>

            <Button
              type="button"
              variant="secondary"
              className="fields-reset"
              onClick={() =>
                setAdjustmentData({
                  employeeName: "",
                  totalAdvanceAmountDisbursed: "",
                  totalActualExpenses: "",
                  balanceAmount: "",
                  adjustmentType: "",
                  adjustmentDate: "",
                  adjustmentMode: "",
                  approvedBy: "",
                  remarks: "",
                  advanceReqId: "",
                  createdBy: userId
                })
              }
            >
              Reset
            </Button>

            <Button
              type="submit"
              variant="primary"
              className="fields-submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Saving...
                </>
              ) : (
                "Save Adjustment"
              )}
            </Button>

          </div>

        </Form>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default BalanceAdjustmentAdvanceReq;